import { apiRoutes } from '@/constants/api-routes';
import { apiRequest } from './http';

/**
 * Public affiliate-link telemetry. Distinct from the account-scoped affiliate
 * dashboard fetch (`accountsService.getAffiliate`) — this fires for anonymous
 * visitors landing on a share link, so it must never require auth or throw
 * into a page-load path.
 */
export const affiliateService = {
  /**
   * Fire-and-forget click beacon. Called from `lib/referral.ts` when a valid
   * `?ref=<code>` is captured at boot. The server dedupes to one unique
   * visitor (hashed IP) per month, so calling on every capture is safe.
   * Resolves 204 (empty). Callers should swallow errors — a failed beacon
   * must not surface to the visitor.
   */
  recordClick(code: string): Promise<void> {
    return apiRequest<void>(apiRoutes.affiliate.click, {
      method: 'POST',
      body: { code },
    });
  },
};
